import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@cowsquare/design';
import { Elements } from 'react-stripe-elements';
import { RowTitle } from './MedicalContent';
import CardSection from './CardSection';
import VisaIcon from '../asset/icon_visa.svg';
import MastercardIcon from '../asset/icon_mastercard.svg';

const PaymentWrapper = styled(Box).attrs({
  mr: [0, 5],
  mb: [4, 0],
  px: 6,
  pt: 5,
  pb: 6,
  width: ['100%', 572],
})`
  background-color: white;
`;

const CheckoutForm = props => {
  return (
    <PaymentWrapper>
      <Flex flexDirection="row" justifyContent="space-between">
        <RowTitle>Payment</RowTitle>
        <Box>
          <img src={VisaIcon} alt="support visa" />
          <img src={MastercardIcon} alt="support mastercard" />
        </Box>
      </Flex>
      <Elements>
        <CardSection {...props} />
      </Elements>
    </PaymentWrapper>
  );
};

export default CheckoutForm;
